import { render, staticRenderFns } from "./SettingsHeader.vue?vue&type=template&id=8e16e360&"
import script from "./SettingsHeader.vue?vue&type=script&setup=true&lang=js&"
export * from "./SettingsHeader.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.10.1_css-loader@6.8.1_lodash@4.17.21_vue-template-compiler@2.7.14_webpack@5.88.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports